<template>
    <div class="column_center_start coupon" :class="{ selected: isCouponSelected }" @click="isCouponSelected? unselectedCoupon() : selectCoupon()">
        <div class="row_center_start" style="width: 100%; padding-bottom: 10px; height: 28px">
            <div class="checkbox" :class="{ selected: isCouponSelected }"></div>
            <text class="title">{{ coupon.title }}</text>
        </div>
        <div class="coupon_description">
            <text class="description">{{ coupon.text }}</text>
        </div>
        <div class="row_center_end" style="width: 100%">
            <text class="read-more">{{ '<詳情>' }}</text>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        coupon: {
            type: Object,
            default: () => {
                return {};
            },
            required: true,
        },
    },
    data() {
        return {
            isCouponSelected: false
        };
    },
    mounted() {
        if (this.getSelectedCoupon) {
            // 用三元判斷式判斷此張折價卷是否已經使用過
            this.getSelectedCoupon.id === this.coupon.id ? this.isCouponSelected = true : this.isCouponSelected = false
        }
    },
    computed: {
        getSelectedCoupon() {
            return this.$store.state.cart.selectedCoupon
        },
    },
    watch: {
        getSelectedCoupon() {
            if (this.getSelectedCoupon) {
                this.getSelectedCoupon.id === this.coupon.id ? this.isCouponSelected = true : this.isCouponSelected = false
            }
        },
    },
    methods: {
        selectCoupon() {
            this.$store.commit("cart/setSelectedCoupon", this.coupon)
            this.isCouponSelected = true
        },
        unselectedCoupon() {
            this.$store.commit("cart/setSelectedCoupon", null)
            this.isCouponSelected = false
        }
    }
}
</script>
<style lang="scss" scoped>
.coupon {
    width: 100%;
    height: 100px;
    padding: 10px 5%;
    flex-shrink: 0;
    background-color: #EEEEEE;
    border-radius: 8px;
    transition: opacity 0.3s ease;

    .checkbox {
        width: 24px;
        height: 24px;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        border: none;
        background-color: #fff;
        border-radius: 50%;
        margin-right: 10px;
    }

    .checkbox.selected {
        width: 14px;
        height: 14px;
        border: 5px solid #FACB06;
    }
}

.coupon.selected {
    border: 1px solid #FACB06;
}

.coupon_description {
    flex-grow: 1;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* 限制顯示的行數 */
    -webkit-box-orient: vertical;
    white-space: normal;
}

.description {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* 限制顯示的行數 */
    -webkit-box-orient: vertical;
    white-space: normal;
    padding: 0;
    border: none;
}

.read-more {
    color: #FD5001;
    height: 20px;
}
</style>
